import { render, staticRenderFns } from "./AssetTrendChart.vue?vue&type=template&id=2ef5add6&scoped=true"
import script from "./AssetTrendChart.vue?vue&type=script&lang=js"
export * from "./AssetTrendChart.vue?vue&type=script&lang=js"
import style0 from "./AssetTrendChart.vue?vue&type=style&index=0&id=2ef5add6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5add6",
  null
  
)

export default component.exports